export class OverviewCVDSModel {
	public CVDS = [
		{
			title: 'property information',
			items: [
				{
					class: 'cv-overview-data__info__address',
					path: 'InspectionReport.property.address.streetAddress',
					label: '',
					historical: true
				}
			]
		},
		{
			title: 'appraiser information',
			items: [
				{
					class: '',
					path: 'InspectionReport.borrower',
					label: 'Borrower',
					multipleValues: false,
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.cv_lender.cv_name',
					label: 'Lender',
					multipleValues: false,
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.site.zoning.zoningType',
					label: 'Subject’s Zoning Compliance',
					freddie: true,
					multipleValues: false,
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.site.lot.lotSize',
					label: 'Lot size',
					freddie: true,
					multipleValues: false,
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.site.lot.lotSizeUnits',
					label: 'Lot size units',
					freddie: true,
					multipleValues: false,
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.site.lot.lotSizeEstimate',
					label: 'Lot size estimate',
					freddie: true,
					multipleValues: false,
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.site.siteFeature.adverseSiteConditions',
					label: 'Adverse site conditions',
					freddie: true,
					multipleValues: true,
					multipleValuesSource: {
						source: 'InspectionReport.property.site.siteFeature.adverseSiteConditions',
						items: ['adverseType']
					},
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.structures.effectiveAge',
					label: 'Structures effective age',
					freddie: true,
					multipleValues: true,
					multipleValuesSource: {
						source: 'InspectionReport.property.structures',
						items: ['structureType', 'effectiveAge']
					},
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.propertyAnalysis.propertyQualityRating',
					label: 'Property analysis',
					freddie: true,
					multipleValues: false,
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.site.offSiteFeature.road.yearRoundAccessIndicator',
					label: 'Year round access indicator',
					freddie: true,
					multipleValues: false,
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path:
						'InspectionReport.property.site.siteFeature.nonResidentialUses.nonResidentialUseType',
					label: 'Non residential uses',
					freddie: true,
					multipleValues: true,
					multipleValuesSource: {
						source: 'InspectionReport.property.site.siteFeature.nonResidentialUses',
						items: ['nonResidentialUseType']
					},
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.site.siteUtility.electricalServices.typicalIndicator',
					label: 'Electrical services',
					freddie: true,
					multipleValues: true,
					multipleValuesSource: {
						source: 'InspectionReport.property.site.siteUtility.electricalServices',
						items: ['typicalIndicator']
					},
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.site.siteUtility.sewerServices.typicalIndicator',
					label: 'Sewer services',
					freddie: true,
					multipleValues: true,
					multipleValuesSource: {
						source: 'InspectionReport.property.site.siteUtility.sewerServices',
						items: ['typicalIndicator']
					},
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.site.siteUtility.waterServices.typicalIndicator',
					label: 'Water services',
					freddie: true,
					multipleValues: true,
					multipleValuesSource: {
						source: 'InspectionReport.property.site.siteUtility.waterServices',
						items: ['typicalIndicator']
					},
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.site.siteUtility.gasServices.typicalIndicator',
					label: 'Gas services',
					freddie: true,
					multipleValues: true,
					multipleValuesSource: {
						source: 'InspectionReport.property.site.siteUtility.gasServices',
						items: ['typicalIndicator']
					},
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.site.offSiteFeature.road.roadTypicalIndicator',
					label: 'Road typical indicator',
					freddie: true,
					multipleValues: false,
					historicalClass: 'cv-overview-data__info__btn-table'
				},
				{
					class: '',
					path: 'InspectionReport.property.site.offSiteFeature.road.alleyTypicalIndicator',
					label: 'Alley typical indicator',
					freddie: true,
					multipleValues: false,
					historicalClass: 'cv-overview-data__info__btn-table'
				}
			]
		}
	];
}
